import { useEffect } from 'react';

const useClosePopoverOnScroll = (
  isOpen: boolean,
  onClose: () => void,
): void => {
  useEffect(() => {
    if (!isOpen) return () => {};

    const handleScrollCapture = (e: Event) => {
      const target = e.target as HTMLElement | null;
      // Don't close when user scrolls inside the popover itself.
      if (target?.closest?.('.bs-popover-inner, .popover')) {
        return;
      }
      onClose();
    };

    document.addEventListener('scroll', handleScrollCapture, true);
    return () => {
      document.removeEventListener('scroll', handleScrollCapture, true);
    };
  }, [isOpen, onClose]);
};

export default useClosePopoverOnScroll;
